import React from 'react';
import Modal from '../Modal';
import styles from './AddClipModal.module.scss';

const AddClipModal = ({ open, onClose, children, ...rest }) => {
  return (
    <Modal className={styles.wrapper} open={open} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
};

export default AddClipModal;
